import { MouseEventHandler, ReactElement, ReactNode, useMemo } from 'react';
import styles from './ui-text-button.module.scss';
import { UIIcon, UIIconName, UISpinner } from '../..';
import { blue, charcoal, red } from '../../styles';

type UITextButtonVariant = 'default' | 'primary' | 'danger';

type UITextButtonProps = {
    children?: ReactNode;
    variant?: UITextButtonVariant;
    type?: 'submit' | 'reset' | 'button' | undefined;
    leftIcon?: UIIconName;
    disabled?: boolean;
    loading?: boolean;
    underline?: boolean;
    onClick?: MouseEventHandler<HTMLButtonElement> | undefined;
};
export function UITextButton(props: UITextButtonProps): ReactElement {
    const {
        children,
        type,
        variant = 'default',
        leftIcon,
        disabled,
        loading,
        underline,
        onClick
    } = props;

    // Variant has a corresponding classname
    const buttonClasses = [styles.button, styles[variant]];

    if (underline) {
        buttonClasses.push(styles.underline);
    }

    const textColor = useMemo(() => {
        switch (variant) {
            case 'default':
                return charcoal;
            case 'primary':
                return blue;
            case 'danger':
                return red;
        }
    }, [variant]);

    return (
        <button
            className={buttonClasses.join(' ')}
            type={type}
            disabled={disabled}
            onClick={onClick}
        >
            {leftIcon && <UIIcon name={leftIcon} color={textColor} size={16} />}
            {children}
            {loading && <UISpinner color={textColor} />}
        </button>
    );
}
